import React from "react";
//  id => Correspondiente al nombre del componente en BD
//  Component => Componente a renderizar
const CatalogAdminEgresadosRoutes = [
    {
        Id: "EGRESADOS_REPORTE_REGISTROS",
        Component: React.lazy(() => import("../pages/Administrativos/Reportes/registros/Egresados")),
    },
    {
        Id: "EGRESADOS_BUSQUEDA_AVANZADA_EGRESADOS",
        Component: React.lazy(() => import("../pages/Administrativos/Reportes/Search/EgresadoSearch")),
    },
    {
        Id: "EGRESADOS_REGISTRO_MATRICULAS_ATRASADAS",
        Component: React.lazy(() => import("../pages/Administrativos/Solicitudes/Solicitud")),
    },
    {
        Id: "EGRESADOS_ADMINISTRACION_USUARIOS",
        Component: React.lazy(() => import("../pages/Administrativos/UsuariosAdmin/AdminUsers")),
    }
];

export default CatalogAdminEgresadosRoutes;